/**
 * BashResultCard — Bash 工具结果的结构化渲染。
 * 区分成功/失败，截断超长输出。
 */

import { memo } from 'react'
import { Terminal, CheckCircle2, XCircle } from 'lucide-react'
import './result-cards.less'

const MAX_PREVIEW_LINES = 20

interface BashResultCardProps {
  success: boolean
  output: string
  truncated: boolean
  totalLines: number
}

export const BashResultCard = memo(function BashResultCard({
  success,
  output,
  truncated,
  totalLines,
}: BashResultCardProps) {
  const StatusIcon = success ? CheckCircle2 : XCircle

  return (
    <div className={`result-card ${success ? 'result-card--success' : 'result-card--error'}`}>
      <div className="result-card__field">
        <Terminal className="result-card__field-icon" />
        <StatusIcon
          className="result-card__field-icon"
          style={{ color: success ? 'oklch(0.60 0.18 155)' : 'oklch(0.58 0.22 27)' }}
        />
        <span className="result-card__field-value">
          {success ? '执行成功' : '执行失败'}
        </span>
        {totalLines > 0 && (
          <span className="text-[0.6rem]" style={{ color: 'oklch(var(--muted-foreground) / 0.4)' }}>
            {totalLines} 行输出
          </span>
        )}
      </div>
      {output && (
        <div className="result-card__code-wrap">
          <pre className="result-card__code">{output}</pre>
          {truncated && (
            <div
              className="text-[0.6rem] px-3 py-1 text-center"
              style={{ color: 'oklch(var(--muted-foreground) / 0.4)', borderTop: '1px solid oklch(var(--border) / 0.2)' }}
            >
              ... 已省略 {totalLines - MAX_PREVIEW_LINES} 行
            </div>
          )}
        </div>
      )}
    </div>
  )
})

export { MAX_PREVIEW_LINES }
